exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html, body, #root {\n  height: 100%;\n  font-family: 'Lato', sans-serif;\n}\n\n#sidebar-nav, #header-nav {\n  font-family: 'Montserrat', sans-serif;\n}\n", ""]);

// exports
